import hacks from './hacks/schemas.js';
import contractBreakdown from './contractBreakdown/schemas.js';
import user from './user/schemas.js';

// AI
import AI from './ai/index.js';

export default { hacks, user, contractBreakdown, AI };
